import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { DropTarget } from 'react-dnd';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  PROJECT_ACTIVE: { id: 'OrderSidebarElement.PROJECT_ACTIVE', defaultMessage: 'Aktiv' },
  PROJECT_FINISHED: { id: 'OrderSidebarElement.PROJECT_FINISHED', defaultMessage: 'Abgeschlossen' },
  RENAME_PROJECT: { id: 'OrderSidebarElement.RENAME_PROJECT', defaultMessage: 'Projekt umbenennen' },
  FINISH_PROJECT: { id: 'OrderSidebarElement.FINISH_PROJECT', defaultMessage: 'Projekt abschließen' },
  REACTIVATE_PROJECT: { id: 'OrderSidebarElement.REACTIVATE_PROJECT', defaultMessage: 'Projekt reaktivieren' },
});

import { CALL } from '../../../helpers/dragTypes';

import OrderTextInput from './OrderTextInput';

const orderTarget = {
  canDrop() {
    return true;
  },
  drop(props, monitor) {
    if (monitor.didDrop()) {
      return;
    }
    const item = monitor.getItem();
    return props.order;
  },
};

@DropTarget(CALL, orderTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  isOverCurrent: monitor.isOver({ shallow: true }),
  canDrop: monitor.canDrop(),
  itemType: monitor.getItemType(),
}))
@injectIntl
export default class OrderSidebarElement extends React.Component {
  state = { isEditing: false };

  render() {
    const { order, connectDropTarget, isOver, canDrop, className, to, onClick, onRename, onToggleActive, intl: { formatMessage } } = this.props;
    const { isEditing } = this.state;
    const isSelected = className && className.includes('active');

    return connectDropTarget(
      <li
        className={classnames('order hover-parent', {
          over: isOver && canDrop,
          finished: !order.active,
        }, className)}
        style={{ position: 'relative' }}
      >
        {isEditing ? (
          <OrderTextInput
            className="new-order new-order-top"
            initialValue={order.name}
            onSave={(name) => {
              this.setState({ isEditing: false });
              if (onRename) onRename(name);
            }}
            onCancel={() => this.setState({ isEditing: false })}
          />
        ) : (
          <Link
            to={to}
            onClick={onClick}
            className="project-card-link"
            style={{ display: 'flex', width: '100%', alignItems: 'center' }}
          >
            <div 
              className="text hover-parent" 
              title={order.name} 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                color: isSelected ? 'var(--card-text-hover)' : (order.active ? 'inherit' : 'var(--text-muted)'),
                width: '100%',
                padding: '10px 0'
              }}
            >
              <div title={order.active ? formatMessage(messages.PROJECT_ACTIVE) : formatMessage(messages.PROJECT_FINISHED)}>
                <i 
                  className={`fa ${order.active ? 'fa-folder-open-o' : 'fa-folder'} project-icon`} 
                  style={{ 
                    color: order.active ? '#3b82f6' : '#9ca3af',
                    textShadow: order.active ? '0 0 8px rgba(59, 130, 246, 0.6)' : '0 0 8px rgba(156, 163, 175, 0.6)',
                    width: '20px',
                    textAlign: 'center',
                    marginRight: '8px',
                    transition: 'all 0.2s ease'
                  }}
                ></i> 
              </div>
              
              <span className="project-name" style={{ 
                flex: 1,
                textDecoration: 'none', 
                whiteSpace: 'nowrap', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis',
                minWidth: 0,
                color: 'inherit'
              }}>
                {order.name}
              </span>
              
              <div className="hover-actions-menu" style={{ display: 'flex', alignItems: 'center', marginLeft: '6px' }}>
                <i 
                  className="fa fa-pencil action-icon" 
                  title={formatMessage(messages.RENAME_PROJECT)}
                  role="button"
                  tabIndex="0"
                  aria-label={formatMessage(messages.RENAME_PROJECT)}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ isEditing: true }); }} 
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); this.setState({ isEditing: true }); } }}
                />
                <i 
                  className={classnames('fa action-icon', { 'fa-check': order.active, 'fa-undo': !order.active })} 
                  title={order.active ? formatMessage(messages.FINISH_PROJECT) : formatMessage(messages.REACTIVATE_PROJECT)}
                  role="button"
                  tabIndex="0"
                  aria-label={order.active ? formatMessage(messages.FINISH_PROJECT) : formatMessage(messages.REACTIVATE_PROJECT)}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (onToggleActive) onToggleActive(); }} 
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); if (onToggleActive) onToggleActive(); } }}
                />
              </div>
            </div>
          </Link>
        )}
      </li>
    );
  }
}
